/** @jsx jsx */
import { React, css, jsx, SessionManager, polished, injectIntl, classNames, getAppStore } from 'jimu-core';
import { Icon } from './icon';
import { Image } from './image';
import { Dropdown, DropdownMenu, DropdownItem, DropdownButton } from './dropdown';
import { Link } from './link';
import defaultMessages from '../translations/default';
import { AlertPopup } from './alert-popup';
import { withStyles, withTheme } from 'jimu-theme';
const IconAccount = require('../icons/default-user.svg');
var UserRole;
(function (UserRole) {
    UserRole["OrgAdmin"] = "org_admin";
    UserRole["OrgPublisher"] = "org_publisher";
    UserRole["OrgUser"] = "org_user";
    UserRole["CustomRoles"] = "custom_roles";
})(UserRole || (UserRole = {}));
const _trainingUrls = {
    administrator: '//www.esri.com/training/main/arcgis-online-administrators',
    publisher: '//www.esri.com/training/main/arcgis-online-publishers',
    user: '//www.esri.com/training/main/arcgis-online-users',
    public: '//www.esri.com/training/main/arcgis-online-training',
    custom: '//www.esri.com/training/main/arcgis-online-training'
};
const _esriCommunityLink = 'https://community.esri.com';
const _myEsriLink = 'https://my.esri.com';
const _arcgisBlogLink = 'https://www.esri.com/arcgis-blog/arcgis-online/';
export class _UserProfile extends React.PureComponent {
    constructor(props) {
        super(props);
        this.__unmount = false;
        this.nls = (id) => {
            return this.props.intl ? this.props.intl.formatMessage({ id: id, defaultMessage: defaultMessages[id] }) : id;
        };
        this.signInOut = () => {
            const { isAppSaved } = this.props;
            // home page, saveStatus is undefined
            if (isAppSaved === undefined || isAppSaved) {
                this.doSignInOut();
            }
            else {
                this.setState({
                    isShowWindowLeaveAlert: true,
                    isShowLeaveAlertPopup: true
                });
            }
        };
        this.signOut = () => {
            this.setState({
                accountPopoverOpen: false
            });
            SessionManager.getInstance().signOut();
        };
        this.signIn = () => {
            this.setState({
                accountPopoverOpen: false
            });
            SessionManager.getInstance().signIn({ fromUrl: '/', popup: false });
        };
        this.toggleAccount = () => {
            this.setState({
                accountPopoverOpen: !this.state.accountPopoverOpen
            });
        };
        this.getMenuInnerStyle = (theme) => {
            return css `
      & {
        background: ${theme.ref.palette.neutral[500]};
        border: 1px solid ${theme.ref.palette.neutral[400]};
        box-shadow: 0 0 10px 2px ${polished.rgba(theme.ref.palette.white, 0.2)};
        border-radius: 2px;
        padding-bottom: ${polished.rem(12)};
        min-width: ${polished.rem(240)};
      }
      .font-size-14 {
        font-size: ${polished.rem(14)};
      }
      .dropdown-menu--inner {
        .center-line {
          border-top: 1px solid ${theme.ref.palette.neutral[700]};
          margin: ${polished.rem(16)};
        }
        &>button {
          & {
            display: block;
            padding-left: ${polished.rem(16)};
            color: ${theme.ref.palette.neutral[1100]};
            margin-bottom: ${polished.rem(4)};
          }
          &>a {
            color: inherit;
            display: block;
            text-decoration: none;
            text-align: left;
            padding: 0;
            background: none;
            border: none;
            &:hover {
              color: inherit;
            }
          }
        }
        &>button:first-of-type {
          padding: 0;
          cursor: auto;
          margin-bottom: ${polished.rem(7)};
          &:hover {
            background: none;
          }
        }
        .user-message-con {
          & {
            align-items: center;
            padding: ${polished.rem(16)} ${polished.rem(16)} ${polished.rem(18)} ${polished.rem(16)};
            border-bottom: 1px solid ${theme.sys.color.divider.primary};
          }
          .head-portrait-con {
            & {
              width: ${polished.rem(50)};
              height: ${polished.rem(50)};
              margin-right: ${polished.rem(16)};
            }
            img, button {
              display: block;
              width: 100%;
              height: 100%;
            }
          }
          circle{
            fill: ${theme.sys.color.secondary.dark};
          }
          svg {
            color: ${theme.ref.palette.neutral[1000]};
            margin-right: 0;
          }
          .user-message {
            & {
              font-size: ${polished.rem(14)};
              line-height:${polished.rem(20)};
            }
            div{
              color: ${theme.ref.palette.neutral[1100]};
              max-width: ${polished.rem(142)};
            }
            .user-account {
              color: ${theme.ref.palette.neutral[1000]};
              margin-top: ${polished.rem(11)};
            }
          }
        }
      }
    `;
        };
        this.getTrainingUrl = () => {
            const { user } = this.props;
            const role = user === null || user === void 0 ? void 0 : user.role;
            switch (role) {
                case UserRole.OrgAdmin:
                    return _trainingUrls.administrator;
                case UserRole.OrgPublisher:
                    return _trainingUrls.publisher;
                case UserRole.OrgUser:
                    return _trainingUrls.user;
                default:
                    return _trainingUrls.custom;
            }
        };
        this.handleToggleForLeaveAlertPopup = (isOk) => {
            this.setState({
                isShowLeaveAlertPopup: !this.state.isShowLeaveAlertPopup
            });
            if (isOk) {
                this.doSignInOut();
            }
            else {
                this.setState({ isShowWindowLeaveAlert: false });
            }
        };
        this.doSignInOut = () => {
            const { isShowWindowLeaveAlert } = this.state;
            if (isShowWindowLeaveAlert) {
                window.onbeforeunload = () => null;
            }
            const session = SessionManager.getInstance().getMainSession();
            session ? this.signOut() : this.signIn();
        };
        this.state = {
            accountPopoverOpen: false,
            isShowWindowLeaveAlert: false,
            isShowLeaveAlertPopup: false
        };
    }
    render() {
        var _a;
        const { user, theme, portalUrl } = this.props;
        const session = SessionManager.getInstance().getMainSession();
        let userThumbnail;
        if (user.thumbnail) {
            userThumbnail = `${portalUrl}/sharing/rest/community/users/${user.username}/info/${user.thumbnail}`;
            if (session) {
                userThumbnail = `${userThumbnail}?token=${session === null || session === void 0 ? void 0 : session.token}`;
            }
        }
        const isDevEdition = window.jimuConfig.isDevEdition;
        // for userType, ref: https://devtopia.esri.com/WebGIS/arcgis-webappbuilder/blob/develop/client/builder/plugins/header/Plugin.js#L130
        const isPortalAndUserTypeBoth = (!isDevEdition && (user === null || user === void 0 ? void 0 : user.userType) === 'both');
        const isInPortal = window.jimuConfig.isInPortal;
        const appState = getAppStore().getState();
        // we don't set 'appState.isWebTier' for portal edition, so use 'portalSelf.isWebTierAuth' to chenck webTier
        const isWebTier = appState.isWebTier || ((_a = appState.portalSelf) === null || _a === void 0 ? void 0 : _a.isWebTierAuth);
        return (jsx("div", { className: classNames('jimu-user-profile d-flex ml-1 mr-1', this.props.className) },
            jsx(Dropdown, { size: 'sm', toggle: this.toggleAccount, isOpen: this.state.accountPopoverOpen },
                jsx(DropdownButton, { size: 'sm', type: 'tertiary', icon: true, arrow: false, className: 'p-0 account-dropdown-toggle', "aria-label": this.nls('avatar') },
                    jsx("div", { id: 'accountPopover', className: 'header-account float-left d-flex align-items-center', style: { cursor: 'pointer' }, title: this.props.user && this.props.user.firstName ? this.props.user.firstName : '' }, userThumbnail
                        ? jsx(Image, { src: userThumbnail, width: 26, height: 26, shape: 'circle', className: 'd-block float-left header-login' })
                        : jsx(Icon, { icon: IconAccount, width: 26, height: 26, className: 'd-block float-left header-login' }))),
                jsx(DropdownMenu, { css: this.getMenuInnerStyle(theme) },
                    jsx(DropdownItem, null,
                        jsx("div", { className: 'd-flex user-message-con' },
                            jsx("div", { className: 'head-portrait-con ' },
                                userThumbnail && jsx(Image, { src: userThumbnail, width: 50, height: 50, shape: 'circle', className: 'd-block float-left header-login' }),
                                !userThumbnail && jsx(Icon, { icon: IconAccount, width: 50, height: 50, className: 'd-block float-left header-login' })),
                            jsx("div", { className: 'user-message flex-grow-1' },
                                session && jsx("div", { className: 'text-truncate', title: user.firstName }, user === null || user === void 0 ? void 0 : user.firstName),
                                session && jsx("div", { className: 'user-account text-truncate', title: user === null || user === void 0 ? void 0 : user.username }, user === null || user === void 0 ? void 0 : user.username)))),
                    session && jsx(DropdownItem, null,
                        jsx("a", { target: '_blank', className: 'font-size-14', href: `${this.props.portalUrl}/home/user.html`, rel: "noopener noreferrer" }, this.nls('myProfile'))),
                    !isDevEdition && jsx(DropdownItem, null,
                        jsx(Link, { to: `${this.props.portalUrl}/home/user.html#settings`, target: '_blank' }, this.nls('mySettings'))),
                    isPortalAndUserTypeBoth && jsx(DropdownItem, null,
                        jsx(Link, { to: _esriCommunityLink, target: '_blank' }, this.nls('communityAndForums'))),
                    isPortalAndUserTypeBoth && jsx(DropdownItem, null,
                        jsx(Link, { to: _myEsriLink, target: '_blank' }, this.nls('myEsri'))),
                    isPortalAndUserTypeBoth && jsx(DropdownItem, null,
                        jsx(Link, { to: this.getTrainingUrl(), target: '_blank' }, this.nls('training'))),
                    isPortalAndUserTypeBoth && jsx(DropdownItem, null,
                        jsx(Link, { to: _arcgisBlogLink, target: '_blank' }, this.nls('arcgisBlog'))),
                    jsx(DropdownItem, null,
                        jsx(Link, { to: this.props.helpUrl, target: '_blank' }, this.nls('accountHelp'))),
                    jsx("div", { className: 'center-line' }),
                    (session && !isDevEdition && !window.jimuConfig.isInPortal) && jsx(DropdownItem, { className: 'font-size-14', onClick: () => { SessionManager.getInstance().switchAccount(); } }, this.nls('switchAccount')),
                    !(isInPortal && isWebTier) &&
                        // For webTier portal embedded version, it can only sign-out by close browser, so hide signOut button for this situation.
                        jsx(DropdownItem, { className: 'font-size-14', onClick: () => { this.signInOut(); } }, session ? this.nls('signOut') : this.nls('signIn')))),
            jsx(AlertPopup, { isOpen: this.state.isShowLeaveAlertPopup, okLabel: this.nls('profileLeave'), title: this.nls('profileLeaveSite'), toggle: this.handleToggleForLeaveAlertPopup },
                jsx("div", { style: { fontSize: '1rem' } }, this.nls('profileLeaveDescription')))));
    }
}
export const UserProfile = withStyles(withTheme(injectIntl(_UserProfile)), 'UserProfile');
